<template>
  <div class="userSet_main">
    <div class="systemSet" v-loading="$store.state.loading">
      <div class="titleBox" style="    justify-content: space-between;
">
        <span>用户管理</span>
        <button class="btn-1" style="margin-right: 24px;"@click="
        ($refs.addUserDialog.visible = true),
        ($refs.addUserDialog.formLabelAlign = {})
        ">
                新增
            </button>
      </div>

      <el-divider></el-divider>
      <div style=" width: 99%">
            <el-table size="mini" ref="Table" :data="userList" class="Table" :row-class-name="tableRowClassName"
            :highlight-current-row="true" :row-style="{ fontSize: '0.875rem', color: '#B4B4B4', height: '3rem' }"
      :header-cell-style="{
                fontSize: '0.875rem',
                color: 'rgba(127, 132, 136, 1)',
                borderColor: '#244447',
                backgroundColor: 'rgba(180, 180, 180, .1)',
                height: '3.375rem',
            }">
      <el-table-column header-align="center" align="center" label="序号">
        <template slot-scope="scope">
          {{ (pageNo - 1) * pageSize + (scope.row.index + 1) }}
        </template>
      </el-table-column>
      <el-table-column header-align="center" align="center" prop="username" label="帐号">
      </el-table-column>
      <el-table-column header-align="center" align="center" prop="nickname" label="昵称">
      </el-table-column>
      <el-table-column header-align="center" align="center" :formatter="roleFormatter" label="角色">
      </el-table-column>
  
      <!-- <el-table-column header-align="center" align="center" prop="remark" label="备注">
      </el-table-column> -->
      <el-table-column align="center" label="操作">
        <template slot-scope="scope">
          <span class="text2" @click="edit(scope.row, 1)"> 编辑</span>
          <span class="text2" @click="deleteUser(scope.row.id)"> 删除</span>
          <!-- <span v-if="$store.state.user.username != scope.row.username" class="text2" @click="edit(scope.row, 2)">
            修改密码</span> -->
        </template>
      </el-table-column>
    </el-table>
        </div>
        <Pagination
          style="margin: 0px auto; display: table"
          :total="total"
          :page.sync="pageNo"
          :limit.sync="pageSize"
          @pagination="getUserList"
        ></Pagination>
        <addUserDialog ref="addUserDialog" @getUserList="getUserList"></addUserDialog>
    <editUserDialog ref="editUserDialog" @getUserList="getUserList"></editUserDialog>
    </div>
  </div>
</template>
  
<script>
import Pagination from "@/components/Pagination.vue";
import addUserDialog from "./addUserDialog.vue";
import editUserDialog from './editUserDialog.vue';
export default {
  components: {Pagination,addUserDialog,editUserDialog},
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("新密码不能为空"));
      } else {
        if (this.ruleForm.checkpasswd !== "") {
          this.$refs.ruleForm.validateField("checkpasswd");
        }
        callback();
      }
    };
    var validatePass3 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("旧密码不能为空"));
      } else {
        if (this.ruleForm.oldpasswd !== "") {
          this.$refs.ruleForm.validateField("oldpasswd");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.ruleForm.newpasswd) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };

    return {
      userList:[],
      pageNo: 1,
      pageSize: 10,
      total: 0,
      activeNames: ["0"],
      ruleForm: {
        name: "管理员",
        region: "",
        oldpasswd: "",
        newpasswd: "",
        checkpasswd: "",
      },
      rules: {
        newpasswd: [{ validator: validatePass, trigger: "blur" }],
        oldpasswd: [{ validator: validatePass3, trigger: "blur" }],
        checkpasswd: [{ validator: validatePass2, trigger: "blur" }],
      },
      options: [
        {
          value: "选项1",
          label: "重要",
        },
        {
          value: "选项2",
          label: "不重要",
        },
      ],
    };
  },
  mounted() {
    this.getUserList();
    this.getSiteList();
  },
  methods: {
    getSiteList() {
      this.$api.elevator.getSiteList().then((res) => {
        if (res.code == 200) {
          this.$store.state.siteList = res.data;
        }
      });
    },
    edit(row, flag) {
      this.$refs.editUserDialog.visible = true;
      this.$refs.editUserDialog.flag = flag;
      this.$refs.editUserDialog.formLabelAlign = row;
    },
    roleFormatter(row) {
      switch (row.role) {
        case 1:
          return '超级管理员'
        case 2:
          return '普通管理员'
        case 3:
          return '普通管理员(温度)'
      }
    },
    deleteUser(id) {
      this.$confirm('是否确定删除该用户？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const params = {
          id: id,
        };
        this.$api.user.deleteUser(params).then((res) => {
          if (res.code == 200) {
            this.getUserList()
            this.$message.success('删除成功')
          } else {
            this.$message.error(res.msg)
          }
        });
      }).catch(() => { });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    getUserList() {
      const params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      };
      this.$api.user.page(params).then((res) => {
        if (res.success) {
          this.userList = res.data.records;
          this.total = res.data.total;
        }
      });
    },
  
    handleChange(val) {
      console.log(val);
    },
    tableRowClassName({ row, rowIndex }) {
      //配置表格行的index
      row.index = rowIndex;
    },
  },
  computed: {},
};
</script>
  
<style lang="less" scoped>
.userSet_main{
  width: 100%;
  height: 100%;
  font-size: 1.5rem;
  z-index: 15;
  overflow: auto;
  box-sizing: border-box;
  display: flex;
  /deep/ .el-table__row>td,
    th {
        border-color: var(--tableLine-color);
    }

    /deep/ .el-table .cell {
        line-height: 1.5rem !important;
    }

    /deep/ .el-pagination {
        display: flex;
        align-items: center;
        height: 1.75rem !important;
    }

    /deep/ .el-pagination .el-select .el-input {
        width: 6.25rem !important;
    }

    /deep/ .el-pagination .btn-next .el-icon {
        font-size: 0.75rem !important;
    }

    /deep/ .el-pagination .btn-prev .el-icon {
        font-size: 0.75rem !important;
    }

    /deep/ .el-pagination__total {
        font-size: 0.875rem !important;
        min-width: 2.2188rem !important;
    }

    /deep/ .el-pagination .el-select .el-input .el-input__inner {
        font-size: 0.875rem !important;
        width: 6.25rem !important;
    }

    /deep/ .el-pager li {
        padding: 0 0.25rem !important;
        font-size: 0.8125rem !important;
        min-width: 2.2188rem !important;
    }

    /deep/ .el-pagination button,
    .el-pagination span:not([class*="suffix"]) {
        min-width: 2.2188rem !important;
    }

    /deep/ .el-pagination__jump {
        margin-left: 1.5rem !important;
        font-size: 0.8125rem !important;
    }
}

.systemSet {
  background: var(--cardbg-color);
width: 100%;
height: 100%;
  /deep/.el-form-item__content {
    display: flex;
    align-items: center;
  }
  /deep/ .el-input.is-disabled .el-input__inner {
    width: 16.25rem;
    height: 2.6875rem;
    background: #64999f27;
    border: 0.125rem solid #244447;
    border-radius: 0rem;
    color: #ffffff;
    font-size: 1rem !important;
  }
  /deep/.el-collapse-item__header {
    width: 5.3125rem !important;
    font-size: 0.875rem !important;
    font-family: SourceHanSansCN-Regular, SourceHanSansCN !important;
    font-weight: 400 !important;
    color: #5bb3bc !important;
    line-height: 0.875rem !important;
  }
  .text {
    font-size: 1.75rem;
    font-weight: bold;
    color: #ffffff;
  }

  /deep/.el-divider {
    background-color: #244447;
    margin-top: 1rem;
    margin-bottom: 0.9375rem;
  }

  .Table {
    width: 99%;
    background-color: transparent;
    .text2 {
      cursor: pointer;
      border-bottom: 0.0625rem solid;
      padding-bottom: 0.0625rem;
    }
  }
}
.head {
  /deep/ .el-form-item {
    margin-bottom: 1.25rem;
  }
  /deep/ .el-input__inner {
    width: 16.25rem;
    height: 2.5rem;
    background: #64999f27;
    border: 0.125rem solid #244447;
    border-radius: 0rem;
    color: #ffffff;
    font-size: 1rem !important;
  }
  /deep/ .el-form-item__label {
    color: #fff;
    font-size: 1rem !important;
  }
}


.btn-cancel {
  width: 8.125rem;
  height: 1.875rem;
  border-radius: 0.125rem;
  border: 0.0625rem solid #6c9cb5;
  background: transparent;
  color: white;
  font-size: 0.875rem;
  cursor: pointer;
}
.btn-cancel:hover {
  background: #124f55;
}
.titleBox {
  display: flex;
  align-items: center;
  margin: 0.8125rem 0rem 0rem 1.5rem;
  border-left: 1px rgb(68, 215, 182) solid;

  span {
    width: 6.25rem;
    height: 1rem;
    font-size: 1rem;
    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
    font-weight: 400;
    color: rgb(68, 215, 182);
    line-height: 1.125rem;
    padding-left: 1.25rem;
  }
}

.btn3 {
  width: 8.125rem;
  height: 1.875rem;
  background: #219E82;
  border-radius: 0.125rem;
  border: 0.0625rem solid #219E82;
  color: white;
  font-size: 0.875rem;
  cursor: pointer;
  margin: 1.875rem 1.25rem;
}
.btn3:hover {
  background: #44D7B6;
}

.btn3:disabled {
  cursor: not-allowed;
  background: #325f63;
}
.btn4 {
  width: 8.125rem;
  height: 1.875rem;
  border-radius: 0.125rem;
  border: 0.0625rem solid #44D7B6;
  background: transparent;
  color: #44D7B6;
  font-size: 0.875rem;
  cursor: pointer;
  margin: 1.875rem 1.25rem;
}
.btn4:hover {
  background: #44D7B655;
}
.btn-1 {
        margin-left: 15px;
        width: 4.6875rem;
    height: 1.875rem;
        background: #44d7b6;
        border-radius: 2px;
        color: #ffffff;
        border: none;
        cursor: pointer;
    }

    .btn-1:hover {
        background: #66f8d7;
    }

    .btn-1:active {
        background: #299f85;
    }
@media screen and (max-width: 1440px) {
  .titleBox {
    display: flex;
    align-items: center;
    margin: 13px 0px 0px 24px;
    border-left: 1px rgb(68, 215, 182) solid;

    span {
      width: 100px;
      height: 16px;
      font-size: 16px;
      font-family: SourceHanSansCN-Regular, SourceHanSansCN;
      font-weight: 400;
      color: rgb(68, 215, 182);
      line-height: 18px;
      padding-left: 20px;
    }
  }
}
</style>
  


// WEBPACK FOOTER //
// src/pages/systemSet/userManagement/index.vue